var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"calc(100vh - 120px)"}},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.clearPolygons()}}},[_vm._v("Temizle")]),_c('div',{ref:"mapDrawArea",staticStyle:{"width":"100%","height":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }